import * as React from "react";
import styled from "styled-components";
import { Color } from "../../../constants/legacy";

type Props = {
  imageSrc: string | undefined;
  text: string | undefined;
};

export default function Stat({ imageSrc, text }: Props) {
  return (
    <StyledContainer>
      <div className="img-wrap">
        {imageSrc && <img srcSet={`${imageSrc} 2x`} />}
      </div>
      {text && <p>{text}</p>}
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 20px;

  .img-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125px;
    height: 105px;
  }

  p {
    margin: 15px 0 0;
    color: ${Color.lightGrey};
    max-width: 200px;
    text-align: center;
    font-size: 15px;
  }
`;
